'use strict';

var lodash = require('lodash');
var processValues = require('../processValues/processValues.js');

const getValidArrayValues = ({ fieldKey, fieldValues, getFieldState, values })=>{
    const validValues = {};
    fieldValues.forEach((item, itemIndex)=>{
        const subFieldKeyPath = `${fieldKey}.${itemIndex}`;
        const result = processValues.processValues({
            values,
            subsetValues: item,
            keyPath: subFieldKeyPath,
            getFieldState
        });
        lodash.merge(validValues, result);
    });
    // filter any nullish values left by `pick`
    if (validValues[fieldKey] != null && Array.isArray(validValues[fieldKey])) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call
        validValues[fieldKey] = validValues[fieldKey].filter((o)=>o);
    }
    return validValues;
};

exports.getValidArrayValues = getValidArrayValues;
//# sourceMappingURL=getValidArrayValues.js.map
